import SectionHeading from "./SectionHeading.jsx";
import { partnerItems } from "./data.js";

export default function Partner() {
  return (
    <section className="bg-white px-4 py-10 sm:px-6 lg:px-8 lg:py-20">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-end">
          <SectionHeading
            title="For Brands"
            highlight="& E-Commerce"
          />
          <br className="hidden md:block" />
          <p className="max-w-2xl text-lg leading-8 text-[#0d0828b3] font-montserrat">
            Increase ROI while lowering CAC. Reach buyers who&apos;ve already saved
            for your product, the highest-intent buyers on the internet.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {partnerItems.map((item) => (
            <div
              key={item.title}
              className="rounded-[28px] border border-purple-100 bg-[#fcfbff] p-8 transition duration-300 md:hover:-translate-y-1 md:hover:shadow-[0_20px_50px_rgba(124,58,237,0.08)]"
            >
              <div className="inline-flex rounded-2xl py-1 text-4xl font-black tracking-[0.18em] text-white">
                {item.icon}
              </div>
              <h3 className="mt-5 text-2xl font-black font-montserrat tracking-[-0.03em] text-[#0d0828]">
                {item.title}
              </h3>
              <p className="mt-4 text-base leading-7 text-[#0d0828b3] font-montserrat">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
